import React, { Component, Fragment } from 'react';
import moment from 'moment-timezone';
import { Trans, translate } from 'react-i18next';

import * as $ from 'jquery';

class Summary extends Component {

  horarioSala = (start, end) => {
    return (
      <div className="panel-body">
        {start + " - " + end}
      </div>
    )
  }

  render() {
    const center = this.props.center;
    const reservation = this.props.RoomBook
    const paymentDetails = this.props.paymentDetails
    const count = this.props.count ? this.props.count.capacidad : 0 
    const endDate = moment(reservation.fecha_final, 'YYYY-MM-DD HH:mm:ss');
    const startDate = moment(reservation.fecha_inicial, 'YYYY-MM-DD HH:mm:ss');
    const { t } = this.props;

    return (
      <div className="card-panel panel panel-default card card_cowork card__summary">
        <div className="panel-heading" style={{
          backgroundImage: "url('" + reservation.nombre_imagen + "')",
          borderRadius: '7px',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backgroundBlendMode: 'overlay',
        }}>
          <div className="panel-heading-text">
            <h4 className="panel-title card__text__inside">{t('dashboard.room_payment.heading_summary')}</h4>
          </div>
        </div>
        <div className="panel-body">
          <div className="contenedor-flexbox">
            {center ? (
              <div className="contenedor">
                <i className="fa fa-map-marker" aria-hidden="true"></i>
                {" "}{center.direccion},{center.ciudad},{center.estado}
              </div>
            ) : (
              <div className="contenedor">
                <i className="fa fa-map-marker" aria-hidden="true"></i>
                {" "}{reservation.name}
              </div>
            )}
            <div className="contenedor">
              <i className="fa fa-users" aria-hidden="true">
              </i>
              {" "}
              <Trans i18nKey='dashboard.reservations.capacity'>
                {{ count }}
              </Trans>
            </div>
            <div className="contenedor">
              <i className="fa fa-calendar" aria-hidden="true"></i>
              {" "}{startDate.format('ll')}
            </div>
            <div className="contenedor">
              <i className="fa fa-clock-o" aria-hidden="true"></i>
              {" "}{startDate.format('HH:mm')} - {endDate.format('HH:mm')}
            </div>
            {center ? (
              <div className="contenedor">
                <i className="fa fa-building-o" aria-hidden="true"></i>
                {" "}{center.name}
              </div>
            ) : null}
          </div>
          {paymentDetails ? (
            <div className="panel-footer">
              <div className="contenedor-flexbox-card">
                <div className="col-xs-5">
                  <p>{t('dashboard.room_payment.subtotal')}</p>
                </div>
                <div className="col-xs-7 text-primary">
                  <p>{"$" + Number(paymentDetails.subtotal).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                {
                  Number(paymentDetails.credits) > 0 && (
                    <Fragment>
                      <div className="col-xs-5">
                        <p>{t('dashboard.room_payment.discount')}</p>
                      </div>
                      <div className="col-xs-7 text-primary">
                        <p>{"$" + Number(paymentDetails.credits).toFixed(2) + " " + paymentDetails.currency}</p>
                      </div>
                    </Fragment>
                  )
                }
                <div className="col-xs-5">
                  <p>{t('dashboard.room_payment.iva')}</p>
                </div>
                <div className="col-xs-7 text-primary">
                  <p>{"$" + Number(paymentDetails.iva).toFixed(2) + " " + paymentDetails.currency}</p>
                </div>
                <div className="col-xs-5">
                  <p><strong>{t('dashboard.room_payment.total')}</strong></p>
                </div>
                <div className="col-xs-7 text-primary">
                  <p><strong>{"$" + Number(paymentDetails.total).toFixed(2) + " " + paymentDetails.currency}</strong></p>
                </div>
              </div>
              {/* <div className="form-group text-center">
                <button className="btn btn-primary btn-singup btn-resvations" onClick={this.props.handlePromocodeClick}>PROMOCODE</button>
              </div> */}
            </div>
          ) : null}
        </div>
        <button
          className="btn btn-lg btn-secondary"
          type="button"
          style={{
            marginInline: "0px",
            height: '45%', width: '100%', borderRadius: '45px'
          }}
          onClick={() => $('#btnSuccessHelp').click()}
        >
          <span>
            <Trans>dashboard.contact.holder_message</Trans>
          </span>
        </button>

      </div>
    );
  }
}

export default translate('common')(Summary);



// WEBPACK FOOTER //
// ./src/store/Payment/Summary.js